export default function MagnifyingWithCrossIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="#F03800"
        d="m6.219 15.207-1.977 3.055a1.578 1.578 0 1 1-2.184-2.184l3.06-1.976 1.1 1.105Z"
      />
      <path
        fill="#FF641A"
        d="M7.879 13.55a1.172 1.172 0 0 1-1.656 1.656l-1.106-1.105a1.172 1.172 0 0 1 1.656-1.657L7.88 13.55Z"
      />
      <path
        fill="#4F737C"
        d="M12.02 14.941a6.64 6.64 0 1 0 0-13.281 6.64 6.64 0 0 0 0 13.281Z"
      />
      <path
        fill="#ECECF1"
        d="M15.516 4.808a4.942 4.942 0 1 1-6.989 0 4.938 4.938 0 0 1 6.989 0Z"
      />
      <path
        fill="currentColor"
        d="M18.527 2.969c.215 0 .391.176.391.39 0 .215-.176.391-.39.391a.392.392 0 0 1-.391-.39.39.39 0 0 1 .39-.391Zm0 14.062c.215 0 .391.176.391.39 0 .216-.176.391-.39.391a.392.392 0 0 1-.391-.39.39.39 0 0 1 .39-.39ZM16.38.625a.585.585 0 1 1 .001 1.17.585.585 0 0 1-.001-1.17ZM11.69 17.031a.585.585 0 1 1 .002 1.17.585.585 0 0 1-.002-1.17ZM4.465 1.016c.215 0 .39.175.39.39 0 .215-.175.39-.39.39a.392.392 0 0 1-.39-.39.39.39 0 0 1 .39-.39ZM2.512 9.609a.392.392 0 0 1 0 .781.392.392 0 0 1-.39-.39.39.39 0 0 1 .39-.39Zm-.586-4.687a.585.585 0 1 1 .001 1.17.585.585 0 0 1-.001-1.17ZM12.02 15.328c-1.801 0-3.602-.684-4.973-2.055a7.04 7.04 0 0 1 0-9.945A6.985 6.985 0 0 1 12.02 1.27a7.027 7.027 0 0 1 7.03 7.03 7.024 7.024 0 0 1-7.03 7.028Zm0-13.277a6.195 6.195 0 0 0-4.418 1.832 6.257 6.257 0 0 0 0 8.84c3.914 3.914 10.668 1.132 10.668-4.418a6.247 6.247 0 0 0-6.25-6.254Z"
      />
      <path
        fill="currentColor"
        d="M8.25 12.074a5.342 5.342 0 0 1 0-7.543 5.342 5.342 0 0 1 7.543 0 5.342 5.342 0 0 1 0 7.543 5.342 5.342 0 0 1-7.543 0Zm.55-6.992a4.56 4.56 0 0 0 0 6.438 4.56 4.56 0 0 0 6.438 0 4.56 4.56 0 0 0 0-6.438 4.56 4.56 0 0 0-6.437 0ZM5.946 15.484a.389.389 0 1 1 .551-.55.783.783 0 0 0 1.106-1.106l-1.106-1.105a.781.781 0 1 0-1.102 1.102.389.389 0 1 1-.55.55 1.562 1.562 0 1 1 2.21-2.21L8.16 13.27c.61.609.61 1.597 0 2.21-.3.297-1.605.614-2.215.004Z"
      />
      <path
        fill="black"
        d="M.957 17.2a1.961 1.961 0 0 1 .887-1.445l3.054-1.977a.39.39 0 0 1 .489.05l1.105 1.106a.39.39 0 0 1 .051.489L4.57 18.477A1.971 1.971 0 0 1 .957 17.2Zm4.105-2.598-2.789 1.805a1.19 1.19 0 1 0 1.645 1.645l1.805-2.79-.66-.66Zm4.594-3.933a.389.389 0 0 1 0-.55l4.297-4.298a.389.389 0 1 1 .55.551l-4.296 4.297a.389.389 0 0 1-.55 0Z"
      />
      <path
        fill="black"
        d="M13.953 10.669 9.656 6.372a.389.389 0 1 1 .551-.55l4.297 4.296a.389.389 0 1 1-.55.55Z"
      />
    </svg>
  );
}
